import { CustomerEnquiryConstant } from "presentation/constant/CustomerEnquiry/CustomerEnquiryConstant";
import { useCustomerEnquiryVM } from "presentation/hook/CustomerEnquiry/useCustomerEnquiryVM";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CustomerEnquiryTitleBar: React.FC = () => {
    const customerEnquiryVM = useCustomerEnquiryVM();




    const handleSearch = useCallback(async () => {
        customerEnquiryVM.onSearchClick();
    }, [customerEnquiryVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{CustomerEnquiryConstant.Title.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
        </StyledAction>
    </Sidebarheader>
}

export default memo(CustomerEnquiryTitleBar);